export enum ResidencePurpose {
  DRIVER_LICENSE = 'DRIVER_LICENSE',

  VEHICLE_TRANSFER = 'VEHICLE_TRANSFER',

  BANK_ACCOUNT = 'BANK_ACCOUNT',

  OTHER = 'OTHER',
}
